import dutch from "./dutch";
import hungarian from "./hungarian";
import english from "./english";
import portuguese from "./portuguese";
import italian from "./italian";
import spanish from "./spanish";

export default {
	english,
}